const hook = {
    missing_events: '少なくとも1つのイベントを提供する必要があります。',
    send_test_payload_failed: 'テストペイロードの送信に失敗しました：{{message}}',
    endpoint_responded_with_error: 'エンドポイントがエラーで応答しました：{{message}}。',
};
export default Object.freeze(hook);
